import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

import { ISSUES_LIST_PERMISSION, ISSUES_PATH } from '&/features/issues/paths';
import { issuesListSearchSchema } from '&/features/issues/lib/issues-list-search';
import { requireModule } from '&/lib/module-gate';

export const Route = createFileRoute('/_authenticated/issues')({
  beforeLoad: ({ context }): void => {
    // Entitlement: a tenant without the Maintenance module (per the registry) gets the standard
    // not-found. Covers client-side navigation only; the page wraps itself in <ModuleGate> for the
    // hard-refresh case.
    requireModule(context.entitlement, ISSUES_PATH);
    // Permission gate (separate concern): a viewer without `issues:list` goes back to the Dashboard.
    if (context.permissions.isReady && !context.permissions.hasPermission(ISSUES_LIST_PERMISSION)) {
      throw redirect({ to: '/' });
    }
  },
  component: lazyRouteComponent(() => import('&/features/issues/pages/issues-page')),
  staticData: { titleKey: 'issues' },
  validateSearch: issuesListSearchSchema,
});
